/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![VoiceWarningIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwklEQVR4nN2VP0sjQRTAFS200ZyNqK2gpY0W/iGFhTmy788Kk/cSkbSKn8BC8BOI9t59AU9B0EYEMWKhhahYWAk2ggrHXSuCMptN2KyJ7hoLdWBh583w+82+NzvT0PAVWjKZbAaWDSRdN8Y0xQa47lQXslwgyUG1cXR1Dlmf7AMss7HgqdRUG7CclADh8XQ69wNZ7oH1t33sO1E+EQlujGkF1v0SvJoASJdtPJ02PYja7X/FUhR4k81pEB4WOJPZfiB5sHHHzQwyZ4c8gY2h6XuN34isq2F4WAAs2+Xckxwh6XGgv1X5qayH1YBYQ+Cw/AzGiWTY4exoZSwzURZEgWNAACznwbiFE8lYxXzS0zoEuhdh/u67BbHbpxQYYzqQ5S+yXtt+Mp9vsX0gufkQAbDOF4spO7ZPlBso/mh6WbfAIZkG0kcP6GrKE5Is+P/Ar7oFQPrPhy366WoHkltvy5KMvxSQHMQRIOtMaeX2WAGWNT89hSg1byyejPrmLrIrR5Y/xXH5D2B641wimzVTBNrp5Zz0rgyfzIxEgoeO60KNFF2VYnZO5JWHG1E+gSxnL4ssK3a3VC3oe69MiFjA79WeAZym1W/WfP7yAAAAAElFTkSuQmCC)
 */
export const VoiceWarningIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.09 1.63c.4-.7 1.43-.7 1.82 0l3.96 6.9c.38.66-.12 1.47-.91 1.47h-7.92c-.79 0-1.3-.81-.91-1.48l3.96-6.9Zm.46 1.87h.9c.3 0 .52.26.5.55l-.22 2.02c-.01.16-.17.26-.33.23a1.92 1.92 0 0 0-.8 0c-.16.03-.32-.07-.33-.23l-.21-2.02a.5.5 0 0 1 .5-.55ZM19 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M11 2a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1h-.06a1 1 0 0 1-.74-.32L5.92 17H3a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h2.92l4.28-4.68a1 1 0 0 1 .74-.32H11ZM20.5 12c-.28 0-.5.22-.52.5a7 7 0 0 1-5.13 6.25c-.48.13-.85.55-.85 1.05v.03c0 .6.52 1.06 1.1.92a9 9 0 0 0 6.89-8.25.48.48 0 0 0-.49-.5h-1ZM16.5 12c-.28 0-.5.23-.54.5a3 3 0 0 1-1.33 2.02c-.35.23-.63.6-.63 1.02v.14c0 .63.59 1.1 1.16.83a5 5 0 0 0 2.82-4.01c.02-.28-.2-.5-.48-.5h-1Z"
        className={colorClass}
      />
    </svg>
  );
};
